import React from "react";
import { ReactComponent as ProfileIcon } from "assets/icons/profile.svg";
import { ReactComponent as VideoCameraIcon } from "assets/icons/video-camera.svg";
import { ReactComponent as FlipCameraIcon } from "assets/icons/flip-camera.svg";
import { ReactComponent as MicrophoneIcon } from "assets/icons/microphone.svg";
import { ReactComponent as SpeakerIcon } from "assets/icons/speaker.svg";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";
import { ReactComponent as PresentIcon } from "assets/icons/present.svg";
import { ReactComponent as GearIcon } from "assets/icons/gear.svg";
import { ReactComponent as InfoIcon } from "assets/icons/info.svg";
import { ReactComponent as SlashIcon } from "assets/icons/slash.svg";
import { ReactComponent as UsersIcon } from "assets/icons/users.svg";
import { ReactComponent as ChevronLeftIcon } from "assets/icons/chevron-left.svg";
import { ReactComponent as ChevronRightIcon } from "assets/icons/chevron-right.svg";
import { ReactComponent as ChatIcon } from "assets/icons/chat.svg";
interface IconProps {
  /** The svg file name. */
  id: string;
  /** Custom styles to apply to the icon. */
  className?: string;
}

/** An icon wrapper component. Declare any new icons that are added to
 * the project here.
 */
export const Icon: React.FC<IconProps> = ({ id, className }: IconProps) => {
  return (function () {
    switch (id) {
      case "profile":
        return <ProfileIcon className={className} />;
      case "video-camera":
        return <VideoCameraIcon className={className} />;
      case "flip-camera":
        return <FlipCameraIcon className={className} />;
      case "microphone":
        return <MicrophoneIcon className={className} />;
      case "speaker":
        return <SpeakerIcon className={className} />;
      case "close":
        return <CloseIcon className={className} />;
      case "present":
        return <PresentIcon className={className} />;
      case "gear":
        return <GearIcon className={className} />;
      case "info":
        return <InfoIcon className={className} />;
      case "slash":
        return <SlashIcon className={className} />;
      case "users":
        return <UsersIcon className={className} />;
      case "chevron-left":
        return <ChevronLeftIcon className={className} />;
      case "chevron-right":
        return <ChevronRightIcon className={className} />;
      case "chat":
        return <ChatIcon className={className} />;
      default:
        return null;
    }
  })();
};
